const deepReplace = (value, replacements) => {
  if (typeof value === 'string') {
    return Object.entries(replacements).reduce((next, [key, replacement]) => {
      return next.split(`{{${key}}}`).join(replacement);
    }, value);
  }

  if (Array.isArray(value)) {
    return value.map((item) => deepReplace(item, replacements));
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, child]) => [
        key,
        deepReplace(child, replacements),
      ])
    );
  }

  return value;
};

export const composeModelRestExamples = (model, templateLibrary) => {
  const resolved = [];
  const overrides = new Map(
    (model?.rest_examples || []).map((item) => [item.id, item])
  );

  (model?.example_groups || []).forEach((groupId) => {
    (templateLibrary?.groups?.[groupId] || []).forEach((example) => {
      resolved.push({
        ...example,
        ...(overrides.get(example.id) || {}),
      });
    });
  });

  return resolved;
};

export const buildExampleCurl = (example, context) => {
  const body = deepReplace(example?.request_body || {}, {
    model: context?.modelId || '',
    imageUrl: '{{imageUrl}}',
    document_text: '{{document_text}}',
    baseUrl: context?.baseUrl || '',
  });

  return `curl --location '${context?.baseUrl || ''}${example?.endpoint || ''}' \\
--header 'Authorization: Bearer ${context?.apiKey || 'YOUR_API_KEY'}' \\
--header 'Content-Type: application/json' \\
--data '${JSON.stringify(body, null, 2)}'`;
};

export const buildLoadableParams = (requestBody, replacements = {}) => {
  const resolvedBody = deepReplace(requestBody || {}, replacements);
  const next = {};
  Object.entries(resolvedBody).forEach(([key, value]) => {
    next[key] =
      value !== null && typeof value === 'object'
        ? JSON.stringify(value, null, 2)
        : value;
  });
  return next;
};
